export class Utilits {
    static copy(val: string){
        try
        {
            navigator.clipboard.writeText(val);
        }
        catch(ex)
        {
            console.log('error on try copy to clipboard', ex);
        }
    }

    static focus(elId: string){
        setTimeout(()=>{ document.getElementById(elId)?.focus() },0);
    }

    static decodeHtml(html: string) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    static patternsTextPrepare(val: string): string{
        return val.replace(/","/g,'",\n"');
    }
}
